(function (angular, undefined) {
    'use strict';

    angular
        .module('blocks.context.menu', []);
})(angular);